const ContabilidadRules  = () => {

  return {
    IdContabilidad: [
      'int',
      'digits:6',
    ]
  }
};

export default ContabilidadRules;
